function filterCollections() {
    var $filterByCategory = $('#CategoryFilter');
    var $filterByTitle = $('#TitleFilter');
    var $filterByColor = $('#ColorFilter');

    let categories = $filterByCategory.val();
    let titles = $filterByTitle.val();
    let colors = $filterByColor.val();

    var categoryFilter = "";
    var titleFilter = "";
    var colorFilter = "";

    if(categories == null) {
        categoryFilter += '';
    }
    else {
        categories.forEach((category, index, array) => {
            var formattedCategory = category.toLowerCase().replace(" ", "_");
            if(formattedCategory == "category" || formattedCategory == "all" || formattedCategory == null) {
                categoryFilter += '';
            }
            else {
                if(index === array.length - 1) {
                    categoryFilter += '[data-category="' + formattedCategory + '"]';
                }
                else {
                    categoryFilter += '[data-category="' + formattedCategory + '"],';
                }
            }
        })
    }

    if(titles == null) {
        titleFilter += '';
    }
    else {
        titles.forEach((title, index, array) => {
            if(title == "title" || title == "all" || title == null) {
                titleFilter += '';
            }
            else {
                if(index === array.length - 1) {
                    titleFilter += '[data-title="' + title + '"]';
                }
                else {
                    titleFilter += '[data-title="' + title + '"],';
                }
            }
        })
    }

    if(colors == null) {
        colorFilter += '';
    }
    else {
        colors.forEach((color, index, array) => {
            if(color == "color" || color == "all" || color == null) {
                colorFilter += '';
            }
            else {
                if(index === array.length - 1) {
                    colorFilter += '[data-color="' + color + '"]';
                }
                else {
                    colorFilter += '[data-color="' + color + '"],';
                }
            }
        })
    }

    var $targets;
    if(categoryFilter && titleFilter && colorFilter) {
        var $targets = $('.CollectionProduct').filter(categoryFilter).filter(titleFilter).filter(colorFilter)
    }
    else if(categoryFilter && titleFilter && !colorFilter) {
        var $targets = $('.CollectionProduct').filter(categoryFilter).filter(titleFilter);
    }
    else if(categoryFilter && !titleFilter && !colorFilter) {
        var $targets = $('.CollectionProduct').filter(categoryFilter);
    }
    else if(categoryFilter && !titleFilter && colorFilter) {
        var $targets = $('.CollectionProduct').filter(categoryFilter).filter(colorFilter);
    }
    else if(!categoryFilter && titleFilter && colorFilter) {
        var $targets = $('.CollectionProduct').filter(titleFilter).filter(colorFilter);
    }
    else if(!categoryFilter && !titleFilter && colorFilter) {
        var $targets = $('.CollectionProduct').filter(colorFilter);
    }
    else if(!categoryFilter && titleFilter && !colorFilter) {
        var $targets = $('.CollectionProduct').filter(titleFilter);
    }
    else {
        var $targets = $('.CollectionProduct');
    }

    $targets.show()
    $('.CollectionProduct').not($targets).hide();
    if($targets.length == 0) {
        $("#collection_results_message").show();
    }
    else {
        $("#collection_results_message").hide();
    }
}

function showFilters () {
    let $categoryDrop;
    let $titleDrop;
    let $colorDrop;
  	let filtersShown = false;

    // funzione che mostra/nasconde i filtri su mobile 
    $('#filters-section').toggleClass('show');
    filtersShown = !filtersShown;
  
   $categoryDrop = $("#CategoryFilter + .select2.select2-container.select2-container--default");
   $titleDrop = $("#TitleFilter  + .select2.select2-container.select2-container--default");
   $colorDrop = $("#ColorFilter  + .select2.select2-container.select2-container--default");
  
   let open = [''];
  
   // funzione per rimuovere tutti i margini creati per i dropdown tranne la variabile open su versione mobile
   let closeAll = function () {

     if(open[0] != $categoryDrop[0]) $categoryDrop.css("marginBottom", 0);
     if(open[0] != $titleDrop[0]) $titleDrop.css("marginBottom", 0);
     if(open[0] != $colorDrop[0]) $colorDrop.css("marginBottom", 0);
   };
  
  $(window).click( function() {
      closeAll()
  })
  
  $('select').each(function() {
    $(this).on('select2:close', function() {
      $(this).next().css("marginBottom", 0);
        open = [''];
    })
  })
  

  
  //click listeners che aspettano il click sul dropdown per spostare il contenuto verso il basso
  
  $categoryDrop.click(function() {
      if($("#select2-CategoryFilter-results").outerHeight() != undefined) {
        open = $(this);
        $titleDrop.css("marginBottom", 0);
        $colorDrop.css("marginBottom", 0);
        $(this).css("marginBottom", $("#select2-CategoryFilter-results").outerHeight())
        setTimeout(() => {
           window.scrollBy(0, 1);
           window.scrollBy(0, -1);
        }, 10);
    } else {
        $(this).css("marginBottom", 0);
    }     
  })
  $titleDrop.click(function() {
      if($("#select2-TitleFilter-results").outerHeight() != undefined) {
        open = $(this);
        $categoryDrop.css("marginBottom", 0);
        $colorDrop.css("marginBottom", 0);
        $(this).css("marginBottom", $("#select2-TitleFilter-results").outerHeight())
        setTimeout(() => {
           window.scrollBy(0, 1);
           window.scrollBy(0, -1);
        }, 10);
    } else {
        $(this).css("marginBottom", 0);
    }     
  })
  $colorDrop.click(function() {
    if($("#select2-ColorFilter-results").outerHeight() != undefined) {
      open = $(this);
      $categoryDrop.css("marginBottom", 0);
      $titleDrop.css("marginBottom", 0);
      $(this).css("marginBottom", $("#select2-ColorFilter-results").outerHeight())
      setTimeout(() => {
         window.scrollBy(0, 1);
         window.scrollBy(0, -1);
      }, 10);
  } else {
      $(this).css("marginBottom", 0);
  }     
})
}

function resetFilters() {
    $("#CategoryFilter").val(null).trigger('change');
    $("#TitleFilter").val(null).trigger('change');
    $("#ColorFilter").val(null).trigger('change');
    $('.CollectionProduct').show()
    $('#collection_results_message').hide();
    $(".select2-search__field[aria-describedby=select2-CategoryFilter-container]").removeClass("filtered");
    $(".select2-search__field[aria-describedby=select2-TitleFilter-container]").removeClass("filtered");
    $(".select2-search__field[aria-describedby=select2-ColorFilter-container]").removeClass("filtered");
}

function buildPlaceholder (placeholder, size) {
    if(placeholder.length > size) {
      if (placeholder.indexOf('...') !== -1){
        return placeholder.slice(0, -3 ).slice(0, size - placeholder.length) + '...';
      }
      if (placeholder === placeholder.slice(0, size)) {
        return placeholder;
      } else {
        return placeholder.slice(0, size) + '...';
      }
    }
    return placeholder;  
  };

  function buildPlaceHolderText (categorySelectedFilters) {
    var string = "";
    var mostRecentItems = categorySelectedFilters.reverse();

    if(categorySelectedFilters.length > 2) {
        string = mostRecentItems[0] + ", " + mostRecentItems[1] + "..."
    }
    else {
        string = mostRecentItems.join(", ");
    }
    return string;
  }

  function handleSelectChange (element, triggered, categorySelectedFilters, titleSelectedFilters, colorSelectedFilters) {
    let containerSelector = $(element)[0].id;
    let defaultPlaceholder = "";
    var finalPlaceHolder = "";

    if(containerSelector.includes("Category")) {
        defaultPlaceholder = "Category";
        finalPlaceHolder = buildPlaceHolderText(categorySelectedFilters);
    }
    else if(containerSelector.includes("Title")) {
        defaultPlaceholder = "Title";
        finalPlaceHolder = buildPlaceHolderText(titleSelectedFilters);
    }
    else if(containerSelector.includes("Color")) {
        defaultPlaceholder = "Color";
        finalPlaceHolder = buildPlaceHolderText(colorSelectedFilters);
    }

    let categories = $(element).val();
    let category = "";
    let placeholder = "";
    if(categories == null) {
        $(".select2-search__field[aria-describedby=select2-" + containerSelector + "-container]").removeClass("filtered");
        return;
    }
    else if(categories.length > 0) {
        categories.forEach((categoria) => {
        if(category === "") {
            category = categoria.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
            placeholder = finalPlaceHolder;
        } else {
            placeholder = finalPlaceHolder;
            category = category + "+" + categoria.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
        }
      });
    }
    if(!triggered) {
        if(categories.includes("all") || categories.length === 0) {
          $(".select2-search__field[aria-describedby=select2-" + containerSelector + "-container]").removeClass("filtered");
          $(this).val(null).trigger('change', [true]);
        } else {
         $(".select2-search__field[aria-describedby=select2-" + containerSelector + "-container]").addClass("filtered");
        }
        setTimeout(function(){
          if(category === "" || category.includes("all")){
              $(element).val(null).trigger('change', [true]);
              $("[aria-describedby=select2-" + containerSelector + "-container]").attr("placeholder", "All"); 
          }
          else{
              let size = Math.floor($("[aria-describedby=select2-" + containerSelector + "-container]").width() / 5);
              $("[aria-describedby=select2-" + containerSelector + "-container]").attr("placeholder", buildPlaceholder(placeholder, size));
          }
        }, 100);
      }
  }

$(document).ready(function() {
    let collection_filters = $(".collection_filters_container");
    if(collection_filters.length > 0) {
        //non fa comparire la tastiera su mobile quando clicco su un select multiplo
        $('select').on('select2:opening select2:closing', function(event) {
            var $searchfield = $(this).parent().find('.select2-search__field');
            $searchfield.attr('inputmode','none');
        });

        //Filters multi select
        $("#CategoryFilter").select2({
            minimumResultsForSearch: Infinity,
            multiple: true,
            placeholder: "Category"
        });

        $("#TitleFilter").select2({
            minimumResultsForSearch: Infinity,
            multiple: true,
            placeholder: "Title"
        });

        $("#ColorFilter").select2({
            minimumResultsForSearch: Infinity,
            multiple: true,
            placeholder: "Color"
        });

        $('[aria-describedby=select2-CategoryFilter-container]').attr("placeholder", "Category");
        $('#CategoryFilter').val(null).trigger('change');

        $('[aria-describedby=select2-TitleFilter-container]').attr("placeholder", "Title");
        $('#TitleFilter').val(null).trigger('change');

        $('[aria-describedby=select2-ColorFilter-container]').attr("placeholder", "Color");
        $('#ColorFilter').val(null).trigger('change');

        var categorySelectedFilters = [];
        var titleSelectedFilters = [];
        var colorSelectedFilters = [];

        $("#CategoryFilter").on('select2:select select2:unselect', function(event, triggered) {
            var lastSelected = event.params.data.text;

            if(lastSelected == "Tutto" || lastSelected == "All") {
                categorySelectedFilters = [];
            }
            else if(categorySelectedFilters.indexOf(lastSelected) == -1) {
                categorySelectedFilters.push(lastSelected) 
            } 
            else {
                var result = categorySelectedFilters.filter(function(elem){
                    return elem != lastSelected; 
                });
                categorySelectedFilters = result;
            }
            handleSelectChange($(event.target), triggered, categorySelectedFilters, titleSelectedFilters, colorSelectedFilters)
        })

        $("#TitleFilter").on('select2:select select2:unselect', function(event, triggered) {
            var lastSelected = event.params.data.text;

            if(lastSelected == "Tutto" || lastSelected == "All") {
                titleSelectedFilters = [];
            }
            else if(titleSelectedFilters.indexOf(lastSelected) == -1 ) {
                titleSelectedFilters.push(lastSelected) 
            } 
            else {
                var result = titleSelectedFilters.filter(function(elem){
                    return elem != lastSelected; 
                });
                titleSelectedFilters = result;
            }

            handleSelectChange($(event.target), triggered, categorySelectedFilters, titleSelectedFilters, colorSelectedFilters)
        })

        $("#ColorFilter").on('select2:select select2:unselect', function(event, triggered) {
            var lastSelected = event.params.data.text;
            if(lastSelected == "Tutto" || lastSelected == "All") {
                colorSelectedFilters = [];
            }
            else if(colorSelectedFilters.indexOf(lastSelected) == -1) {
                colorSelectedFilters.push(lastSelected) 
            } 
            else {
                var result = colorSelectedFilters.filter(function(elem){
                    return elem != lastSelected; 
                });
                colorSelectedFilters = result;
            }

            handleSelectChange($(event.target), triggered, categorySelectedFilters, titleSelectedFilters, colorSelectedFilters)
        })



        //handle filters buttons
        $(".filters-button").on("click", function(){
            filterCollections();
        })
        
        $(".filters-reset-button").on("click", function(){
            resetFilters();
            categorySelectedFilters = [];
            titleSelectedFilters = [];
            colorSelectedFilters = [];
        })

        $(".toggle-filters-button").on("click", function(){
            showFilters();
        })
    }
    
})


//Product page Tabs
$(".tabs .tabs__nav a").on("click", function (e) {
    e.preventDefault();
  
    var link = $(this).attr("href");
    var $linkParent = $(this).parent();
    var $tab = $(link);
    var activeClass = "current";
  
    $tab
      .add($linkParent)
      .addClass(activeClass)
      .siblings()
      .removeClass(activeClass);

    //prevent from scolling to anchor tag position
    return false;
  });

  $('.tabs .tabs__nav ul >li').on('mouseover', 'a', function() {
    $(this).parent().siblings().removeClass("current");
  }).on('mouseleave', function() {
    $(this).addClass("current");
  });


/* Accordion mobile menu */

var accordion = document.querySelectorAll(".mobile-nav__link--sublist");
var i;

for (i = 0; i < accordion.length; i++) {
    accordion[i].addEventListener("click", function(e) {
      e.preventDefault()
      this.classList.toggle("active");
      var menu_icons = $(this).find(".menu-icon");
      var panel = this.nextElementSibling;
      if (!this.classList.contains("active")) {
        $(panel).removeAttr("open");
        $(menu_icons).toggleClass("hide");
      } else {
        $(panel).attr("open", "true");
        $(menu_icons).toggleClass("hide")
      } 
    });
  }

    //Product page add to cart form - Disabled on 06/03/2026
    /* if(window.location.href.includes('product') && $('.btn--add-to-cart').length > 0) {
        $(window).on('scroll', function () {
            var top = $(window).scrollTop();
            var headerHeight = $('.header__main').outerHeight();
            var divBottom = $('.tabs__nav').offset().top - headerHeight;
            var initialProductFormHeight = $('.product__form_info').outerHeight();
            
            if (divBottom > top) {
                $('.product__form_info').removeClass('sticky_cart_active');
                $('.product__form_info').css("height", "auto");
            } else {
                var initialHeight = initialProductFormHeight + "px";
                $('.product__form_info').addClass('sticky_cart_active');
                $('.product__form_info').css("height", initialHeight);
            }
        });
    } */

    // hide product price and button 'add to cart' when product price = 0 - 27-03-2026
   if(window.location.href.includes('product') && $('.btn--add-to-cart').length > 0) {
    $(document).ready(function() {
            // Selezioniamo lo span all'interno del contenitore specifico
            const $priceSpan = $('.product__form_info [data-product-price]');

            if ($priceSpan.length > 0) {
                // 1. Prendiamo il testo (es: "€0,00" o "$0.00")
                let priceText = $priceSpan.text();

                // 2. Rimuoviamo tutto ciò che non è un numero, una virgola o un punto
                // Poi sostituiamo la virgola con il punto per renderlo un numero valido (float)
                let priceValue = parseFloat(priceText.replace(/[^0-9,.]/g, '').replace(',', '.'));

                // 3. Verifichiamo se il valore è effettivamente 0
                if (priceValue === 0) {
                // Rimuoviamo lo span del prezzo
                $priceSpan.remove();

                // Rimuoviamo il pulsante aggiungi al carrello tramite ID
                $('#AddToCart--product').remove();

                // Rimuoviamo il div del pagamento Shopify tramite classe
                $('.shopify-payment-button').remove();
                
                console.log("Elementi rimossi: prodotto gratuito o prezzo non disponibile.");
                }
            }
        });
   }

// Availability applied by default on search filters in collection page
document.addEventListener("DOMContentLoaded", function () {
  const filtersList = document.querySelector(".filters-list");
  if (!filtersList) return;

  const formSubmitButton = filtersList.querySelector("input[type='submit']");
  const availableCheckbox = document.getElementById(
    "Filter-filter.v.availability-1"
  );

  if (formSubmitButton && availableCheckbox) {
    formSubmitButton.addEventListener("click", function (event) {
      availableCheckbox.checked = true;
    });
  }
});